// This module runs before analytics initialisation. The fragment never reaches an HTTP server.
let pending = ''
if (typeof window !== 'undefined' && window.location.pathname === '/referrals/verify') {
  const token = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token') || ''
  if (/^[a-f0-9]{64}$/.test(token)) pending = token
  window.history.replaceState(window.history.state, '', window.location.pathname)
}
export function takeReferralLinkToken () { const token = pending; pending = ''; return token }
